import React from "react";
import { cn } from "../lib/helpers";
import Container from "./container";
import ProductItem from "./product-item";

import * as styles from "../styles/components/fc-products.module.css";

interface Slug {
  current?: string;
}

interface ImageAsset {
  asset?: {
    _id: string;
  };
  alt?: string;
}

interface LpSettings {
  image?: ImageAsset;
  specs?: {
    applications?: string;
    colorTemperature?: string;
    optical?: string;
    lumenOutput?: string;
  }
}

interface Series {
  title?: string;
  slug?: Slug;
}

interface Product {
  title?: string;
  slug?: Slug;
  lp?: LpSettings;
  series?: Series;
}

interface ProductItem {
  _key?: string;
  product?: Product;
}

interface ProductsProps {
  title?: string;
  products?: ProductItem[];
}

const Products: React.FC<ProductsProps> = ({
  title,
  products
}) => {
  if (!products || products.length === 0) {
    return null;
  }

  return (
    <div className={styles.root}>
      <Container>
        {title && (<h2 className={styles.title}>{title}</h2>)}

        <div className={cn("grid", styles.items)}>
          {products.map(({ _key, product }) => (
            <ProductItem key={_key} item={product} />
          ))}
        </div>
      </Container>
    </div>
  );
};

export default Products;
